import { useTranslation } from "react-i18next"
import { useCallback } from "react"
import { API_ROUTES } from "../../configuration/RoutesApi"
import type { StoreGroup } from "../../Objects/StoreGroups/StoreGroup"
import { GetRequest } from "../../services/ApiClientService"

export const usePublicStoreGroup = () => {
  const { t } = useTranslation("publicMenu")

  const handleGetPublicStoreGroup = useCallback(
    async (slug: string): Promise<{ group: StoreGroup | null; error: string }> => {
      try {
        const response = await GetRequest<StoreGroup>(API_ROUTES.STORE_GROUPS.PUBLIC(slug))

        if (response.success && response.data) {
          return { group: response.data, error: "" }
        }

        return { group: null, error: response.message || t("store_group.load_error") }
      } catch (error) {
        return {
          group: null,
          error: error instanceof Error ? error.message : t("store_group.load_error"),
        }
      }
    },
    [t],
  )

  return {
    handleGetPublicStoreGroup,
  }
}
